module.exports = __webpack_public_path__ + "img/zettakit.ac7669d5.svg";